import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DigiDocImage from '../../Assets/Images/DigiDoc Head.png';
import SplashImage from '../../Assets/Images/Online Doctor-amico.png';
import './Otp.css';
import config from '../../Config';

const Otp = () => {
  const [otp, setOtp] = useState(new Array(4).fill(''));
  const [errorMessage, setErrorMessage] = useState('');
  const [resendMessage, setResendMessage] = useState('');
  const navigate = useNavigate();
  const mobileNumber = sessionStorage.getItem('mobileNumber'); // Retrieve mobile number from sessionStorage

  useEffect(() => {
    if (!mobileNumber) {
      // If mobileNumber is not in sessionStorage, redirect to the Signin page
      navigate('/signin');
    }
  }, [mobileNumber, navigate]);

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return;

    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);

    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };
  const handleVerify = async () => {
    const enteredOtp = otp.join('');
  
    if (enteredOtp.length === 4) {
      try {
        const response = await fetch(`${config.API_BASE_URL}/patient/verify_otp`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            mobile_no: mobileNumber,
            otp: enteredOtp,
            language_id: '1', // Language ID for English
          }),
        });
  
        if (!response.ok) {
          throw new Error('Invalid OTP');
        }
  
        const result = await response.json();
        console.log(result); // Optional: Log API response
  
        // Store the auth token in sessionStorage
        if (result.token) {
          sessionStorage.setItem('authToken', result.token);
        }
  
        // Navigate based on is_onboarded value
        if (result.data?.is_onboarded === 0) {
          navigate('/welcome'); // Navigate to Welcome page
        } else if (result.data?.is_onboarded === 1) {
          navigate('/home'); // Navigate to Home page
        } else {
          setErrorMessage('Unexpected response. Please contact support.');
        }
      } catch (error) {
        setErrorMessage('Invalid OTP. Please try again.');
        console.error(error);
      }
    } else {
      setErrorMessage('Please enter a 4-digit OTP');
    }
  };
  
  

  const handleResend = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/patient/send_otp`, { // Updated endpoint
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          mobile_no: mobileNumber,
          language_id: '1',
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to send OTP');
      }

      setResendMessage('OTP has been sent successfully.');
      setTimeout(() => setResendMessage(''), 3000); // Clear message after 3 seconds
    } catch (error) {
      setErrorMessage('Failed to send OTP. Please try again later.');
      console.error(error);
    }
  };

  return (
    <div className="otp-page">
      <header className="logo-section">
        <img src={DigiDocImage} alt="DigiDoc" className="logos" />
      </header>
      <div className="illustration-section-otp">
        <img src={SplashImage} alt="Doctor Illustration" className="illustration" />
      </div>
      <div className="otp-container">
        <div className="divider"></div>
        <h4>OTP Verification</h4>
        <small>Enter the OTP sent to +91 {mobileNumber}</small>

        <div className="input-container">
          {otp.map((data, index) => (
            <input
              key={index}
              type="text"
              maxLength="1"
              name="otp"
              value={data}
              onChange={(e) => handleChange(e.target, index)}
              onFocus={(e) => e.target.select()}
            />
          ))}
        </div>

        {errorMessage && <p className="error-message">{errorMessage}</p>}
        {resendMessage && <p className="success-message">{resendMessage}</p>}

        <div className="resend-otp">
          <small>
            Didn't receive OTP?{' '}
            <a href="#" onClick={handleResend}>
              Resend
            </a>
          </small>
        </div>

        <div className="otp-btn margins" onClick={handleVerify}>
          <button className="button-verify">Verify</button>
        </div>
      </div>
    </div>
  );
};

export default Otp;
